# Uses a combination of random and current timestamp
# then encodes the string in base-36 to make it shorter
# https://github.com/google/closure-library/blob/555e0138c83ed54d25a3e1cd82a7e789e88335a7/closure/goog/string/string.js#L1177
module.exports = {
	generate: () ->
		x = 2147483648
		randNum = Math.floor(Math.random() * x)
		msSinceEpoch = new Date().getTime()
		dateNum = Math.abs(Math.floor(Math.random() * x) ^ msSinceEpoch)
		randNum.toString(36) + dateNum.toString(36)
}